export default "/images/ad-studio_logo.png?52e6109e7a646ed175abe8b3937e19e2";